import React, {useState, useEffect, useRef} from 'react';
import { Helmet } from 'react-helmet'


import {Link, NavLink, useLocation, useHistory} from "react-router-dom";
import AlertModal from '../partials/AlertModal'
import CTAModal from '../partials/CTAModal'

import LiveCampaignsContent from '../partials/dashboard/live-campaigns/LiveCampaignsContent'
import DashboardSingleCard from "../partials/dashboard/DashboardSingleCard";
import EmPushyLogo from "../images/empushy_logo_white.png";
import {API, Auth, Storage} from "aws-amplify";

import UserImage07 from '../images/kieran.jpg';
import Slide01 from '../images/landing_slide1.png';
import Slide02 from '../images/landing_slide2.png';
import Slide03 from '../images/landing_slide3.png';
import Slide04 from '../images/landing_slide4.png';
import CallToActionCards from "../partials/ctas/CallToActionCards";
import CTATrendCard from "../partials/ctas/CTATrendCard";
import TopCategoriesCard from "../partials/dashboard/trending-content/TopCategoriesCard";
import CTACampaignsCard from "../partials/ctas/CTACampaignsCard";
import CTAHeatmapCard from "../partials/ctas/CTAHeatmapCard";
import {getDownloadURL, ref as storageRef} from "firebase/storage";
import MissingIcon from "../images/missing.jpg";
import AssociatedNotifItem from "../partials/dashboard/trending-content/AssociatedNotifItem";
import CallToActionCard from "../partials/ctas/CallToActionCard";


function Landing() {

  const search = useLocation().search;
  const state = new URLSearchParams(search).get('s');

  const cta_emojis = {
    'purchase': '💸',
    'awareness': '👀',
    'download': '💾',
    'play': '🎮',
    'feedback': '✍️',
    'claim': '🏆',
    'reminder__advice__tip': '💡',
    'social': '🤳',
    'watch': '📺',
    'discover': '📰',
    'account_management': '⚙️',
  }
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [alertModalState, setAlertModalState] = useState(null)
  const [ctaModalState, setCTAModalState] = useState(null)
  const [contentState, setContentState] = useState('home')
  const [ctaState, setCTAState] = useState('home')
  const [cta, setCTA] = useState({})

  const [trendData, setTrendData] = useState({});
  const [topMarkets, setTopMarkets] = useState([]);
  const [campaigns, setCampaigns] = useState([]);
  const [heatmapData, setHeatmapData] = useState([]);
  const [emotions, setEmotions] = useState([]);
  const [tones, setTones] = useState([]);


  const [cards, setCards] = useState('')
  const [callToActionCards, setCallToActionCards] = useState('')

  const history = useHistory();
  const sidebar = useRef(null);
  const trigger = useRef(null);

  useEffect(() => {
    OnLoad();
  }, []);

  function dateToString(date){
        if(date!==undefined)
            return 'Updated on '+ date.split('T')[0]
        return ''
  }


  async function OnLoad() {

    if(state==='cta')
      setContentState('call-to-actions')
    var vid1 = await Storage.get('videos/live_notifications.mp4',
        { level: 'public', download: false, cacheControl: 'no-cache', contentType: 'video/mp4' })
    var vid2 = await Storage.get('videos/optimal_timing.mp4',
        { level: 'public', download: false, cacheControl: 'no-cache', contentType: 'video/mp4' })
    var vid3 = await Storage.get('videos/trending_content.mp4',
        { level: 'public', download: false, cacheControl: 'no-cache', contentType: 'video/mp4' })
    var vid4 = await Storage.get('videos/competitor_analysis.mp4',
        { level: 'public', download: false, cacheControl: 'no-cache', contentType: 'video/mp4' })
    setCards(
        <div className="grid xl:grid-cols-2 gap-6">
          <DashboardSingleCard
              key="0"
              id="0"
              title="Live Campaigns - Beat FOMO with our Real-time feed"
              textContent="View live notification campaigns currently being pushed across varying apps and markets 🔔 See what's trending right now 🔥"
              mediaContent={vid1}
              likes=""
              state="live-campaigns"
              updateContentState={updateContentState}
              lastUpdated='Updated 2 minutes ago'
              cardLiked={cardLiked}
          />
          <DashboardSingleCard
              key="1"
              id="1"
              title="Optimal Scheduling - When is the best time to engage?"
              textContent="We've analysed                             thousands of campaign delivery times ⌚ Find out when best to engage your audience ⚡"
              mediaContent={vid2}
              likes=""
              state="optimal-scheduling"
              updateContentState={updateContentState}
              lastUpdated='Updated 2 minutes ago'
              cardLiked={cardLiked}
          />
          <DashboardSingleCard
              key="2"
              id="2"
              title="Trending Content - Stuck for ideas?"
              textContent="Check out what buzzwords and taglines                            currently resonate with your target audience ✍️ Save time, be inspired 💡"
              mediaContent={vid3}
              likes=""
              state="trending-content"
              updateContentState={updateContentState}
              lastUpdated='Updated 2 minutes ago'
              cardLiked={cardLiked}
          />
          <DashboardSingleCard
              key="3"
              id="3"
              title="Competitor Analysis - Stay ahead of the game!"
              textContent="Don't have a big                             marketing team? No problem! 👀 View and leverage campaigns by similar apps, websites & brands 📢"
              mediaContent={vid4}
              likes=""
              state="competitor-analysis"
              updateContentState={updateContentState}
              lastUpdated='Updated 2 minutes ago'
              cardLiked={cardLiked}
          />
        </div>
    )

    var cardList = [{
          id: "72ba04b2-0f1a-4dd3-b11a-ca32080894d4",
          title: "Discover",
          textContent: "Campaigns that tease the content to generate curiosity on the users and lead them to engage with the app.",
          mediaContent: "https://empushy-dashboard203001-staging.s3.eu-west-1.amazonaws.com/public/videos/cta_discover.mp4?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIATK2YTNIWLOFKZC3L%2F20220627%2Feu-west-1%2Fs3%2Faws4_request&X-Amz-Date=20220627T144948Z&X-Amz-Expires=900&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEL%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEaCWV1LXdlc3QtMSJHMEUCIQDJ9C7oLFc8ITlpvlU9R5d36hWAe7kLKm7648WsWiz6xAIgNF1FS75SzbzOh6wg%2BpWzlQIy6%2B960tfzxUkRuk%2B5X8wqzQQI2P%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgwyMjk0Mjk3MDExNjQiDN%2BA5NmwVqhcWnbewCqhBLDqf%2B%2BR0f0FH%2FgjOqbyql4BiIi5D%2BSxDkzaFlfai0%2F1UHk3OjiNoVSGEhZssPE5pNEfRC8mxRy1bZpngiLTGifE1q62b29RyQYmx%2B%2Ft0g0ZIc7QmdsTmDOZ%2B%2BITQ9jnSHq0J6RmnuS2X4mjrZ4iCYbwEsitBjTiR48Z9wyeiVH5SbRhQ%2BpJQ6oXtm0nkxpqSq%2FHdV9lrjR7lH4JFFuiSQcCh6QwcGoSEypX5qjZ3Z1Q4K1hIl9C4d9BoQhaXNFOo8QP5jn%2B5ut7HyiN3stwgJMQfpLmd3luzw2UzaB3DWOa9c0E6RnD1Agc%2FIq2SZr5BmHz5X8HbvfNfAHbFEX8KbGWMxR%2BxD57HU45YiIwrVlZ7L9WAS82lJcMjc6rS7efdcfyV6Cksiut4nXVX%2BzZku98sILyg6BTzKWcvxDoybY22w0J%2B%2FTR3dKxhebLVeCVAzLaVdIBuJc0tn0uN2SyRHTzwc%2FUMmL0YtKuRXOm9kqHbwdt06LnWxapRObC1lhXJRt9j7Z0WbJKGrX51s2WCGicnvFlBJIga%2FV0X4Yh%2B32Zz3bskGNuJK1knEV4ufamGKDmB1rZXmeroOvB%2F9Y%2Fy13nSioZ8ZkL0oTpRvliivrt27UnFVGvQiAZGtvTRfCIp3494MyqgkplXmwSAqJxqkN%2Bx7zabbQ223RXqPi8nE3t7KSCxyyqS4%2B%2FWRLO2uhUbpU3w%2BmOJagHnGBGfXZ9%2Bvk%2BMIOD55UGOoUChLHCvi9gZp%2F6YfsxPhAakKtoygm%2FbjuKV3lu7fGAAV7gch3%2FxtsiN7K636NzN0HXU55a0OjPxyqH6Rq8%2BoFM4vuQhE3APIJm0gtbATKw8gTFyb8PEnCt%2FpxSY40NZW8me%2BqDx1kyVq9DXQXlnIyaX34ZPTPhYz57AisaMtoffnDb8sZl9TZw6XBGl4G8l66EzXpKI9EbDJlh4Ml%2Br1XzKT%2BKI9UFbP%2FqlItqykcQXCplIFoFkg0zNXH1zG9CBXBuOENvlcvi8cOMNfnFapwVtGgBfJktj82O%2BxSUaBmHVlzucTkRXezet8rH%2BApwO15khO0HIp6xuF2b77ngLJPiLhHUczGN&X-Amz-Signature=bae888c207aa5d015cd9f7979603e08d4ecd0fe8e8425e231f7d4d927126a29b&X-Amz-SignedHeaders=host&response-cache-control=no-cache&response-content-type=video%2Fmp4&x-amz-user-agent=aws-sdk-js%2F3.6.1%20os%2FWindows%2FNT_10.0%20lang%2Fjs%20md%2Fbrowser%2FChrome_102.0.0.0%20api%2Fs3%2F3.6.1%20aws-amplify%2F4.0.2_js&x-id=GetObject",
          likes: 4,
          state: "discover",
          lastUpdated: "Updated on 2022-06-27",
          videoContent: 'cta_discover.mp4'
      },
          {
              id: "4d312ea7-6707-4ae2-8509-6c0d34a422f7",
              title: "Awareness",
              textContent: "Campaigns that make subscribers aware of information that does not need further investigation by the subscriber, e.g. a new feature, upcoming holiday, weather, stock price, score in a match, etc.",
              mediaContent: "https://empushy-dashboard203001-staging.s3.eu-west-1.amazonaws.com/public/videos/cta_awareness.mp4?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIATK2YTNIWLOFKZC3L%2F20220627%2Feu-west-1%2Fs3%2Faws4_request&X-Amz-Date=20220627T144948Z&X-Amz-Expires=900&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEL%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEaCWV1LXdlc3QtMSJHMEUCIQDJ9C7oLFc8ITlpvlU9R5d36hWAe7kLKm7648WsWiz6xAIgNF1FS75SzbzOh6wg%2BpWzlQIy6%2B960tfzxUkRuk%2B5X8wqzQQI2P%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgwyMjk0Mjk3MDExNjQiDN%2BA5NmwVqhcWnbewCqhBLDqf%2B%2BR0f0FH%2FgjOqbyql4BiIi5D%2BSxDkzaFlfai0%2F1UHk3OjiNoVSGEhZssPE5pNEfRC8mxRy1bZpngiLTGifE1q62b29RyQYmx%2B%2Ft0g0ZIc7QmdsTmDOZ%2B%2BITQ9jnSHq0J6RmnuS2X4mjrZ4iCYbwEsitBjTiR48Z9wyeiVH5SbRhQ%2BpJQ6oXtm0nkxpqSq%2FHdV9lrjR7lH4JFFuiSQcCh6QwcGoSEypX5qjZ3Z1Q4K1hIl9C4d9BoQhaXNFOo8QP5jn%2B5ut7HyiN3stwgJMQfpLmd3luzw2UzaB3DWOa9c0E6RnD1Agc%2FIq2SZr5BmHz5X8HbvfNfAHbFEX8KbGWMxR%2BxD57HU45YiIwrVlZ7L9WAS82lJcMjc6rS7efdcfyV6Cksiut4nXVX%2BzZku98sILyg6BTzKWcvxDoybY22w0J%2B%2FTR3dKxhebLVeCVAzLaVdIBuJc0tn0uN2SyRHTzwc%2FUMmL0YtKuRXOm9kqHbwdt06LnWxapRObC1lhXJRt9j7Z0WbJKGrX51s2WCGicnvFlBJIga%2FV0X4Yh%2B32Zz3bskGNuJK1knEV4ufamGKDmB1rZXmeroOvB%2F9Y%2Fy13nSioZ8ZkL0oTpRvliivrt27UnFVGvQiAZGtvTRfCIp3494MyqgkplXmwSAqJxqkN%2Bx7zabbQ223RXqPi8nE3t7KSCxyyqS4%2B%2FWRLO2uhUbpU3w%2BmOJagHnGBGfXZ9%2Bvk%2BMIOD55UGOoUChLHCvi9gZp%2F6YfsxPhAakKtoygm%2FbjuKV3lu7fGAAV7gch3%2FxtsiN7K636NzN0HXU55a0OjPxyqH6Rq8%2BoFM4vuQhE3APIJm0gtbATKw8gTFyb8PEnCt%2FpxSY40NZW8me%2BqDx1kyVq9DXQXlnIyaX34ZPTPhYz57AisaMtoffnDb8sZl9TZw6XBGl4G8l66EzXpKI9EbDJlh4Ml%2Br1XzKT%2BKI9UFbP%2FqlItqykcQXCplIFoFkg0zNXH1zG9CBXBuOENvlcvi8cOMNfnFapwVtGgBfJktj82O%2BxSUaBmHVlzucTkRXezet8rH%2BApwO15khO0HIp6xuF2b77ngLJPiLhHUczGN&X-Amz-Signature=5dc0b78418ef1765e946d84fd084ffd50711dcf6fac6fbad75356eb23d4ddede&X-Amz-SignedHeaders=host&response-cache-control=no-cache&response-content-type=video%2Fmp4&x-amz-user-agent=aws-sdk-js%2F3.6.1%20os%2FWindows%2FNT_10.0%20lang%2Fjs%20md%2Fbrowser%2FChrome_102.0.0.0%20api%2Fs3%2F3.6.1%20aws-amplify%2F4.0.2_js&x-id=GetObject",
              likes: 1,
              state: "awareness",
              lastUpdated: "Updated on 2022-06-26",
              videoContent: 'cta_awareness.mp4'
          },
          {
              id: "475fbfd9-f102-4325-a2dd-ca113a8c8ad7",
              title: "Feedback",
              textContent: "Campaigns to get the subscriber to provide some form of feedback or response.",
              mediaContent: "https://empushy-dashboard203001-staging.s3.eu-west-1.amazonaws.com/public/videos/feedback.mp4?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIATK2YTNIWLOFKZC3L%2F20220627%2Feu-west-1%2Fs3%2Faws4_request&X-Amz-Date=20220627T144948Z&X-Amz-Expires=900&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEL%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEaCWV1LXdlc3QtMSJHMEUCIQDJ9C7oLFc8ITlpvlU9R5d36hWAe7kLKm7648WsWiz6xAIgNF1FS75SzbzOh6wg%2BpWzlQIy6%2B960tfzxUkRuk%2B5X8wqzQQI2P%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgwyMjk0Mjk3MDExNjQiDN%2BA5NmwVqhcWnbewCqhBLDqf%2B%2BR0f0FH%2FgjOqbyql4BiIi5D%2BSxDkzaFlfai0%2F1UHk3OjiNoVSGEhZssPE5pNEfRC8mxRy1bZpngiLTGifE1q62b29RyQYmx%2B%2Ft0g0ZIc7QmdsTmDOZ%2B%2BITQ9jnSHq0J6RmnuS2X4mjrZ4iCYbwEsitBjTiR48Z9wyeiVH5SbRhQ%2BpJQ6oXtm0nkxpqSq%2FHdV9lrjR7lH4JFFuiSQcCh6QwcGoSEypX5qjZ3Z1Q4K1hIl9C4d9BoQhaXNFOo8QP5jn%2B5ut7HyiN3stwgJMQfpLmd3luzw2UzaB3DWOa9c0E6RnD1Agc%2FIq2SZr5BmHz5X8HbvfNfAHbFEX8KbGWMxR%2BxD57HU45YiIwrVlZ7L9WAS82lJcMjc6rS7efdcfyV6Cksiut4nXVX%2BzZku98sILyg6BTzKWcvxDoybY22w0J%2B%2FTR3dKxhebLVeCVAzLaVdIBuJc0tn0uN2SyRHTzwc%2FUMmL0YtKuRXOm9kqHbwdt06LnWxapRObC1lhXJRt9j7Z0WbJKGrX51s2WCGicnvFlBJIga%2FV0X4Yh%2B32Zz3bskGNuJK1knEV4ufamGKDmB1rZXmeroOvB%2F9Y%2Fy13nSioZ8ZkL0oTpRvliivrt27UnFVGvQiAZGtvTRfCIp3494MyqgkplXmwSAqJxqkN%2Bx7zabbQ223RXqPi8nE3t7KSCxyyqS4%2B%2FWRLO2uhUbpU3w%2BmOJagHnGBGfXZ9%2Bvk%2BMIOD55UGOoUChLHCvi9gZp%2F6YfsxPhAakKtoygm%2FbjuKV3lu7fGAAV7gch3%2FxtsiN7K636NzN0HXU55a0OjPxyqH6Rq8%2BoFM4vuQhE3APIJm0gtbATKw8gTFyb8PEnCt%2FpxSY40NZW8me%2BqDx1kyVq9DXQXlnIyaX34ZPTPhYz57AisaMtoffnDb8sZl9TZw6XBGl4G8l66EzXpKI9EbDJlh4Ml%2Br1XzKT%2BKI9UFbP%2FqlItqykcQXCplIFoFkg0zNXH1zG9CBXBuOENvlcvi8cOMNfnFapwVtGgBfJktj82O%2BxSUaBmHVlzucTkRXezet8rH%2BApwO15khO0HIp6xuF2b77ngLJPiLhHUczGN&X-Amz-Signature=fa09698137f0083bf2b132f25ecad93159db0a7896cf95bf9d4939d72d147355&X-Amz-SignedHeaders=host&response-cache-control=no-cache&response-content-type=video%2Fmp4&x-amz-user-agent=aws-sdk-js%2F3.6.1%20os%2FWindows%2FNT_10.0%20lang%2Fjs%20md%2Fbrowser%2FChrome_102.0.0.0%20api%2Fs3%2F3.6.1%20aws-amplify%2F4.0.2_js&x-id=GetObject",
              likes: 0,
              state: "feedback",
              lastUpdated: "Updated on 2022-06-25",
              videoContent: 'feedback.mp4'
          },
          {
              id: "06b9d093-5320-4936-9f67-330a4f733bef",
              title: "Reminder",
              textContent: "Campaigns that serve as a reminder or alert to the subscribers or provide advice / tips.",
              mediaContent: "https://empushy-dashboard203001-staging.s3.eu-west-1.amazonaws.com/public/videos/reminder_advice_tip.mp4?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIATK2YTNIWLOFKZC3L%2F20220627%2Feu-west-1%2Fs3%2Faws4_request&X-Amz-Date=20220627T144948Z&X-Amz-Expires=900&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEL%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEaCWV1LXdlc3QtMSJHMEUCIQDJ9C7oLFc8ITlpvlU9R5d36hWAe7kLKm7648WsWiz6xAIgNF1FS75SzbzOh6wg%2BpWzlQIy6%2B960tfzxUkRuk%2B5X8wqzQQI2P%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgwyMjk0Mjk3MDExNjQiDN%2BA5NmwVqhcWnbewCqhBLDqf%2B%2BR0f0FH%2FgjOqbyql4BiIi5D%2BSxDkzaFlfai0%2F1UHk3OjiNoVSGEhZssPE5pNEfRC8mxRy1bZpngiLTGifE1q62b29RyQYmx%2B%2Ft0g0ZIc7QmdsTmDOZ%2B%2BITQ9jnSHq0J6RmnuS2X4mjrZ4iCYbwEsitBjTiR48Z9wyeiVH5SbRhQ%2BpJQ6oXtm0nkxpqSq%2FHdV9lrjR7lH4JFFuiSQcCh6QwcGoSEypX5qjZ3Z1Q4K1hIl9C4d9BoQhaXNFOo8QP5jn%2B5ut7HyiN3stwgJMQfpLmd3luzw2UzaB3DWOa9c0E6RnD1Agc%2FIq2SZr5BmHz5X8HbvfNfAHbFEX8KbGWMxR%2BxD57HU45YiIwrVlZ7L9WAS82lJcMjc6rS7efdcfyV6Cksiut4nXVX%2BzZku98sILyg6BTzKWcvxDoybY22w0J%2B%2FTR3dKxhebLVeCVAzLaVdIBuJc0tn0uN2SyRHTzwc%2FUMmL0YtKuRXOm9kqHbwdt06LnWxapRObC1lhXJRt9j7Z0WbJKGrX51s2WCGicnvFlBJIga%2FV0X4Yh%2B32Zz3bskGNuJK1knEV4ufamGKDmB1rZXmeroOvB%2F9Y%2Fy13nSioZ8ZkL0oTpRvliivrt27UnFVGvQiAZGtvTRfCIp3494MyqgkplXmwSAqJxqkN%2Bx7zabbQ223RXqPi8nE3t7KSCxyyqS4%2B%2FWRLO2uhUbpU3w%2BmOJagHnGBGfXZ9%2Bvk%2BMIOD55UGOoUChLHCvi9gZp%2F6YfsxPhAakKtoygm%2FbjuKV3lu7fGAAV7gch3%2FxtsiN7K636NzN0HXU55a0OjPxyqH6Rq8%2BoFM4vuQhE3APIJm0gtbATKw8gTFyb8PEnCt%2FpxSY40NZW8me%2BqDx1kyVq9DXQXlnIyaX34ZPTPhYz57AisaMtoffnDb8sZl9TZw6XBGl4G8l66EzXpKI9EbDJlh4Ml%2Br1XzKT%2BKI9UFbP%2FqlItqykcQXCplIFoFkg0zNXH1zG9CBXBuOENvlcvi8cOMNfnFapwVtGgBfJktj82O%2BxSUaBmHVlzucTkRXezet8rH%2BApwO15khO0HIp6xuF2b77ngLJPiLhHUczGN&X-Amz-Signature=71d0b3f3764b7a1523ca73a8e7a6ba766158bcda2c73acd0ff95ef81773a989d&X-Amz-SignedHeaders=host&response-cache-control=no-cache&response-content-type=video%2Fmp4&x-amz-user-agent=aws-sdk-js%2F3.6.1%20os%2FWindows%2FNT_10.0%20lang%2Fjs%20md%2Fbrowser%2FChrome_102.0.0.0%20api%2Fs3%2F3.6.1%20aws-amplify%2F4.0.2_js&x-id=GetObject",
              likes: 0,
              state: "reminder__advice__tip",
              lastUpdated: "Updated on 2022-06-25",
              videoContent: 'reminder_advice_tip.mp4'
          },
          {
              id: "1cffb562-887a-4992-bede-6b5a828b3b54",
              title: "Claim",
              textContent: "Campaigns that encourage subscribers to click and claim something, such as a prize or reward.",
              mediaContent: "https://empushy-dashboard203001-staging.s3.eu-west-1.amazonaws.com/public/videos/claim.mp4?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIATK2YTNIWLOFKZC3L%2F20220627%2Feu-west-1%2Fs3%2Faws4_request&X-Amz-Date=20220627T144948Z&X-Amz-Expires=900&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEL%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEaCWV1LXdlc3QtMSJHMEUCIQDJ9C7oLFc8ITlpvlU9R5d36hWAe7kLKm7648WsWiz6xAIgNF1FS75SzbzOh6wg%2BpWzlQIy6%2B960tfzxUkRuk%2B5X8wqzQQI2P%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgwyMjk0Mjk3MDExNjQiDN%2BA5NmwVqhcWnbewCqhBLDqf%2B%2BR0f0FH%2FgjOqbyql4BiIi5D%2BSxDkzaFlfai0%2F1UHk3OjiNoVSGEhZssPE5pNEfRC8mxRy1bZpngiLTGifE1q62b29RyQYmx%2B%2Ft0g0ZIc7QmdsTmDOZ%2B%2BITQ9jnSHq0J6RmnuS2X4mjrZ4iCYbwEsitBjTiR48Z9wyeiVH5SbRhQ%2BpJQ6oXtm0nkxpqSq%2FHdV9lrjR7lH4JFFuiSQcCh6QwcGoSEypX5qjZ3Z1Q4K1hIl9C4d9BoQhaXNFOo8QP5jn%2B5ut7HyiN3stwgJMQfpLmd3luzw2UzaB3DWOa9c0E6RnD1Agc%2FIq2SZr5BmHz5X8HbvfNfAHbFEX8KbGWMxR%2BxD57HU45YiIwrVlZ7L9WAS82lJcMjc6rS7efdcfyV6Cksiut4nXVX%2BzZku98sILyg6BTzKWcvxDoybY22w0J%2B%2FTR3dKxhebLVeCVAzLaVdIBuJc0tn0uN2SyRHTzwc%2FUMmL0YtKuRXOm9kqHbwdt06LnWxapRObC1lhXJRt9j7Z0WbJKGrX51s2WCGicnvFlBJIga%2FV0X4Yh%2B32Zz3bskGNuJK1knEV4ufamGKDmB1rZXmeroOvB%2F9Y%2Fy13nSioZ8ZkL0oTpRvliivrt27UnFVGvQiAZGtvTRfCIp3494MyqgkplXmwSAqJxqkN%2Bx7zabbQ223RXqPi8nE3t7KSCxyyqS4%2B%2FWRLO2uhUbpU3w%2BmOJagHnGBGfXZ9%2Bvk%2BMIOD55UGOoUChLHCvi9gZp%2F6YfsxPhAakKtoygm%2FbjuKV3lu7fGAAV7gch3%2FxtsiN7K636NzN0HXU55a0OjPxyqH6Rq8%2BoFM4vuQhE3APIJm0gtbATKw8gTFyb8PEnCt%2FpxSY40NZW8me%2BqDx1kyVq9DXQXlnIyaX34ZPTPhYz57AisaMtoffnDb8sZl9TZw6XBGl4G8l66EzXpKI9EbDJlh4Ml%2Br1XzKT%2BKI9UFbP%2FqlItqykcQXCplIFoFkg0zNXH1zG9CBXBuOENvlcvi8cOMNfnFapwVtGgBfJktj82O%2BxSUaBmHVlzucTkRXezet8rH%2BApwO15khO0HIp6xuF2b77ngLJPiLhHUczGN&X-Amz-Signature=310a6ae0ff7b303cac4bfd2b4dda17a060efcf2dad7c06801d408b70a58ce2f5&X-Amz-SignedHeaders=host&response-cache-control=no-cache&response-content-type=video%2Fmp4&x-amz-user-agent=aws-sdk-js%2F3.6.1%20os%2FWindows%2FNT_10.0%20lang%2Fjs%20md%2Fbrowser%2FChrome_102.0.0.0%20api%2Fs3%2F3.6.1%20aws-amplify%2F4.0.2_js&x-id=GetObject",
              likes: 1,
              state: "claim",
              lastUpdated: "Updated on 2022-06-25",
              videoContent: 'claim.mp4'
          },
          {
              id: "8a31da64-6a84-41c2-8fb3-79abe5a89ee1",
              title: "Account Management",
              textContent: "Campaigns that encourage subscribers to create and/or manage their account.",
              mediaContent: "https://empushy-dashboard203001-staging.s3.eu-west-1.amazonaws.com/public/videos/cta_account_management.mp4?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIATK2YTNIWLOFKZC3L%2F20220627%2Feu-west-1%2Fs3%2Faws4_request&X-Amz-Date=20220627T144948Z&X-Amz-Expires=900&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEL%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEaCWV1LXdlc3QtMSJHMEUCIQDJ9C7oLFc8ITlpvlU9R5d36hWAe7kLKm7648WsWiz6xAIgNF1FS75SzbzOh6wg%2BpWzlQIy6%2B960tfzxUkRuk%2B5X8wqzQQI2P%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgwyMjk0Mjk3MDExNjQiDN%2BA5NmwVqhcWnbewCqhBLDqf%2B%2BR0f0FH%2FgjOqbyql4BiIi5D%2BSxDkzaFlfai0%2F1UHk3OjiNoVSGEhZssPE5pNEfRC8mxRy1bZpngiLTGifE1q62b29RyQYmx%2B%2Ft0g0ZIc7QmdsTmDOZ%2B%2BITQ9jnSHq0J6RmnuS2X4mjrZ4iCYbwEsitBjTiR48Z9wyeiVH5SbRhQ%2BpJQ6oXtm0nkxpqSq%2FHdV9lrjR7lH4JFFuiSQcCh6QwcGoSEypX5qjZ3Z1Q4K1hIl9C4d9BoQhaXNFOo8QP5jn%2B5ut7HyiN3stwgJMQfpLmd3luzw2UzaB3DWOa9c0E6RnD1Agc%2FIq2SZr5BmHz5X8HbvfNfAHbFEX8KbGWMxR%2BxD57HU45YiIwrVlZ7L9WAS82lJcMjc6rS7efdcfyV6Cksiut4nXVX%2BzZku98sILyg6BTzKWcvxDoybY22w0J%2B%2FTR3dKxhebLVeCVAzLaVdIBuJc0tn0uN2SyRHTzwc%2FUMmL0YtKuRXOm9kqHbwdt06LnWxapRObC1lhXJRt9j7Z0WbJKGrX51s2WCGicnvFlBJIga%2FV0X4Yh%2B32Zz3bskGNuJK1knEV4ufamGKDmB1rZXmeroOvB%2F9Y%2Fy13nSioZ8ZkL0oTpRvliivrt27UnFVGvQiAZGtvTRfCIp3494MyqgkplXmwSAqJxqkN%2Bx7zabbQ223RXqPi8nE3t7KSCxyyqS4%2B%2FWRLO2uhUbpU3w%2BmOJagHnGBGfXZ9%2Bvk%2BMIOD55UGOoUChLHCvi9gZp%2F6YfsxPhAakKtoygm%2FbjuKV3lu7fGAAV7gch3%2FxtsiN7K636NzN0HXU55a0OjPxyqH6Rq8%2BoFM4vuQhE3APIJm0gtbATKw8gTFyb8PEnCt%2FpxSY40NZW8me%2BqDx1kyVq9DXQXlnIyaX34ZPTPhYz57AisaMtoffnDb8sZl9TZw6XBGl4G8l66EzXpKI9EbDJlh4Ml%2Br1XzKT%2BKI9UFbP%2FqlItqykcQXCplIFoFkg0zNXH1zG9CBXBuOENvlcvi8cOMNfnFapwVtGgBfJktj82O%2BxSUaBmHVlzucTkRXezet8rH%2BApwO15khO0HIp6xuF2b77ngLJPiLhHUczGN&X-Amz-Signature=7836fdb9d41014b4539e83ede8d0049e965e0a85c1ea83e0837ada80c1a8f2c3&X-Amz-SignedHeaders=host&response-cache-control=no-cache&response-content-type=video%2Fmp4&x-amz-user-agent=aws-sdk-js%2F3.6.1%20os%2FWindows%2FNT_10.0%20lang%2Fjs%20md%2Fbrowser%2FChrome_102.0.0.0%20api%2Fs3%2F3.6.1%20aws-amplify%2F4.0.2_js&x-id=GetObject",
              likes: 0,
              state: "account_management",
              lastUpdated: "Updated on 2022-06-25",
              videoContent: 'cta_account_management.mp4'
          },
          {
              id: "0d9f3a59-899a-4013-82a8-d6c1fea50111",
              title: "Social",
              textContent: "Campaigns that encourage the subscriber to engage with social features e.g. share, like, comment, reply.",
              mediaContent: "https://empushy-dashboard203001-staging.s3.eu-west-1.amazonaws.com/public/videos/social.mp4?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIATK2YTNIWLOFKZC3L%2F20220627%2Feu-west-1%2Fs3%2Faws4_request&X-Amz-Date=20220627T144948Z&X-Amz-Expires=900&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEL%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEaCWV1LXdlc3QtMSJHMEUCIQDJ9C7oLFc8ITlpvlU9R5d36hWAe7kLKm7648WsWiz6xAIgNF1FS75SzbzOh6wg%2BpWzlQIy6%2B960tfzxUkRuk%2B5X8wqzQQI2P%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgwyMjk0Mjk3MDExNjQiDN%2BA5NmwVqhcWnbewCqhBLDqf%2B%2BR0f0FH%2FgjOqbyql4BiIi5D%2BSxDkzaFlfai0%2F1UHk3OjiNoVSGEhZssPE5pNEfRC8mxRy1bZpngiLTGifE1q62b29RyQYmx%2B%2Ft0g0ZIc7QmdsTmDOZ%2B%2BITQ9jnSHq0J6RmnuS2X4mjrZ4iCYbwEsitBjTiR48Z9wyeiVH5SbRhQ%2BpJQ6oXtm0nkxpqSq%2FHdV9lrjR7lH4JFFuiSQcCh6QwcGoSEypX5qjZ3Z1Q4K1hIl9C4d9BoQhaXNFOo8QP5jn%2B5ut7HyiN3stwgJMQfpLmd3luzw2UzaB3DWOa9c0E6RnD1Agc%2FIq2SZr5BmHz5X8HbvfNfAHbFEX8KbGWMxR%2BxD57HU45YiIwrVlZ7L9WAS82lJcMjc6rS7efdcfyV6Cksiut4nXVX%2BzZku98sILyg6BTzKWcvxDoybY22w0J%2B%2FTR3dKxhebLVeCVAzLaVdIBuJc0tn0uN2SyRHTzwc%2FUMmL0YtKuRXOm9kqHbwdt06LnWxapRObC1lhXJRt9j7Z0WbJKGrX51s2WCGicnvFlBJIga%2FV0X4Yh%2B32Zz3bskGNuJK1knEV4ufamGKDmB1rZXmeroOvB%2F9Y%2Fy13nSioZ8ZkL0oTpRvliivrt27UnFVGvQiAZGtvTRfCIp3494MyqgkplXmwSAqJxqkN%2Bx7zabbQ223RXqPi8nE3t7KSCxyyqS4%2B%2FWRLO2uhUbpU3w%2BmOJagHnGBGfXZ9%2Bvk%2BMIOD55UGOoUChLHCvi9gZp%2F6YfsxPhAakKtoygm%2FbjuKV3lu7fGAAV7gch3%2FxtsiN7K636NzN0HXU55a0OjPxyqH6Rq8%2BoFM4vuQhE3APIJm0gtbATKw8gTFyb8PEnCt%2FpxSY40NZW8me%2BqDx1kyVq9DXQXlnIyaX34ZPTPhYz57AisaMtoffnDb8sZl9TZw6XBGl4G8l66EzXpKI9EbDJlh4Ml%2Br1XzKT%2BKI9UFbP%2FqlItqykcQXCplIFoFkg0zNXH1zG9CBXBuOENvlcvi8cOMNfnFapwVtGgBfJktj82O%2BxSUaBmHVlzucTkRXezet8rH%2BApwO15khO0HIp6xuF2b77ngLJPiLhHUczGN&X-Amz-Signature=e615bf931a3b2a1ea3ab8df53066e806cc6347c6d683904f67c88c468c9ab7ef&X-Amz-SignedHeaders=host&response-cache-control=no-cache&response-content-type=video%2Fmp4&x-amz-user-agent=aws-sdk-js%2F3.6.1%20os%2FWindows%2FNT_10.0%20lang%2Fjs%20md%2Fbrowser%2FChrome_102.0.0.0%20api%2Fs3%2F3.6.1%20aws-amplify%2F4.0.2_js&x-id=GetObject",
              likes: 0,
              state: "social",
              lastUpdated: "Updated on 2022-06-25",
              videoContent: 'social.mp4'
          },
          {
              id: "5e4999d7-5d4e-4cc4-8429-50d4fb8a4380",
              title: "Watch",
              textContent: "Campaigns that encourage subscribers to watch and engage with video content.",
              mediaContent: "https://empushy-dashboard203001-staging.s3.eu-west-1.amazonaws.com/public/videos/watch.mp4?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIATK2YTNIWLOFKZC3L%2F20220627%2Feu-west-1%2Fs3%2Faws4_request&X-Amz-Date=20220627T144948Z&X-Amz-Expires=900&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEL%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEaCWV1LXdlc3QtMSJHMEUCIQDJ9C7oLFc8ITlpvlU9R5d36hWAe7kLKm7648WsWiz6xAIgNF1FS75SzbzOh6wg%2BpWzlQIy6%2B960tfzxUkRuk%2B5X8wqzQQI2P%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgwyMjk0Mjk3MDExNjQiDN%2BA5NmwVqhcWnbewCqhBLDqf%2B%2BR0f0FH%2FgjOqbyql4BiIi5D%2BSxDkzaFlfai0%2F1UHk3OjiNoVSGEhZssPE5pNEfRC8mxRy1bZpngiLTGifE1q62b29RyQYmx%2B%2Ft0g0ZIc7QmdsTmDOZ%2B%2BITQ9jnSHq0J6RmnuS2X4mjrZ4iCYbwEsitBjTiR48Z9wyeiVH5SbRhQ%2BpJQ6oXtm0nkxpqSq%2FHdV9lrjR7lH4JFFuiSQcCh6QwcGoSEypX5qjZ3Z1Q4K1hIl9C4d9BoQhaXNFOo8QP5jn%2B5ut7HyiN3stwgJMQfpLmd3luzw2UzaB3DWOa9c0E6RnD1Agc%2FIq2SZr5BmHz5X8HbvfNfAHbFEX8KbGWMxR%2BxD57HU45YiIwrVlZ7L9WAS82lJcMjc6rS7efdcfyV6Cksiut4nXVX%2BzZku98sILyg6BTzKWcvxDoybY22w0J%2B%2FTR3dKxhebLVeCVAzLaVdIBuJc0tn0uN2SyRHTzwc%2FUMmL0YtKuRXOm9kqHbwdt06LnWxapRObC1lhXJRt9j7Z0WbJKGrX51s2WCGicnvFlBJIga%2FV0X4Yh%2B32Zz3bskGNuJK1knEV4ufamGKDmB1rZXmeroOvB%2F9Y%2Fy13nSioZ8ZkL0oTpRvliivrt27UnFVGvQiAZGtvTRfCIp3494MyqgkplXmwSAqJxqkN%2Bx7zabbQ223RXqPi8nE3t7KSCxyyqS4%2B%2FWRLO2uhUbpU3w%2BmOJagHnGBGfXZ9%2Bvk%2BMIOD55UGOoUChLHCvi9gZp%2F6YfsxPhAakKtoygm%2FbjuKV3lu7fGAAV7gch3%2FxtsiN7K636NzN0HXU55a0OjPxyqH6Rq8%2BoFM4vuQhE3APIJm0gtbATKw8gTFyb8PEnCt%2FpxSY40NZW8me%2BqDx1kyVq9DXQXlnIyaX34ZPTPhYz57AisaMtoffnDb8sZl9TZw6XBGl4G8l66EzXpKI9EbDJlh4Ml%2Br1XzKT%2BKI9UFbP%2FqlItqykcQXCplIFoFkg0zNXH1zG9CBXBuOENvlcvi8cOMNfnFapwVtGgBfJktj82O%2BxSUaBmHVlzucTkRXezet8rH%2BApwO15khO0HIp6xuF2b77ngLJPiLhHUczGN&X-Amz-Signature=64d1a58d72f978f32bf536677776447c43fed1f0d2863050960ffc8681d35565&X-Amz-SignedHeaders=host&response-cache-control=no-cache&response-content-type=video%2Fmp4&x-amz-user-agent=aws-sdk-js%2F3.6.1%20os%2FWindows%2FNT_10.0%20lang%2Fjs%20md%2Fbrowser%2FChrome_102.0.0.0%20api%2Fs3%2F3.6.1%20aws-amplify%2F4.0.2_js&x-id=GetObject",
              likes: 0,
              state: "watch",
              lastUpdated: "Updated on 2022-06-25",
              videoContent: 'watch.mp4'
          },
          {
              id: "9ab3ad2c-6ec7-4fc4-8c35-f65d6971af9c",
              title: "Play",
              textContent: "Campaigns encouraging subscribers to play or engage with gaming features.",
              mediaContent: "https://empushy-dashboard203001-staging.s3.eu-west-1.amazonaws.com/public/videos/play.mp4?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIATK2YTNIWLOFKZC3L%2F20220627%2Feu-west-1%2Fs3%2Faws4_request&X-Amz-Date=20220627T144948Z&X-Amz-Expires=900&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEL%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEaCWV1LXdlc3QtMSJHMEUCIQDJ9C7oLFc8ITlpvlU9R5d36hWAe7kLKm7648WsWiz6xAIgNF1FS75SzbzOh6wg%2BpWzlQIy6%2B960tfzxUkRuk%2B5X8wqzQQI2P%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgwyMjk0Mjk3MDExNjQiDN%2BA5NmwVqhcWnbewCqhBLDqf%2B%2BR0f0FH%2FgjOqbyql4BiIi5D%2BSxDkzaFlfai0%2F1UHk3OjiNoVSGEhZssPE5pNEfRC8mxRy1bZpngiLTGifE1q62b29RyQYmx%2B%2Ft0g0ZIc7QmdsTmDOZ%2B%2BITQ9jnSHq0J6RmnuS2X4mjrZ4iCYbwEsitBjTiR48Z9wyeiVH5SbRhQ%2BpJQ6oXtm0nkxpqSq%2FHdV9lrjR7lH4JFFuiSQcCh6QwcGoSEypX5qjZ3Z1Q4K1hIl9C4d9BoQhaXNFOo8QP5jn%2B5ut7HyiN3stwgJMQfpLmd3luzw2UzaB3DWOa9c0E6RnD1Agc%2FIq2SZr5BmHz5X8HbvfNfAHbFEX8KbGWMxR%2BxD57HU45YiIwrVlZ7L9WAS82lJcMjc6rS7efdcfyV6Cksiut4nXVX%2BzZku98sILyg6BTzKWcvxDoybY22w0J%2B%2FTR3dKxhebLVeCVAzLaVdIBuJc0tn0uN2SyRHTzwc%2FUMmL0YtKuRXOm9kqHbwdt06LnWxapRObC1lhXJRt9j7Z0WbJKGrX51s2WCGicnvFlBJIga%2FV0X4Yh%2B32Zz3bskGNuJK1knEV4ufamGKDmB1rZXmeroOvB%2F9Y%2Fy13nSioZ8ZkL0oTpRvliivrt27UnFVGvQiAZGtvTRfCIp3494MyqgkplXmwSAqJxqkN%2Bx7zabbQ223RXqPi8nE3t7KSCxyyqS4%2B%2FWRLO2uhUbpU3w%2BmOJagHnGBGfXZ9%2Bvk%2BMIOD55UGOoUChLHCvi9gZp%2F6YfsxPhAakKtoygm%2FbjuKV3lu7fGAAV7gch3%2FxtsiN7K636NzN0HXU55a0OjPxyqH6Rq8%2BoFM4vuQhE3APIJm0gtbATKw8gTFyb8PEnCt%2FpxSY40NZW8me%2BqDx1kyVq9DXQXlnIyaX34ZPTPhYz57AisaMtoffnDb8sZl9TZw6XBGl4G8l66EzXpKI9EbDJlh4Ml%2Br1XzKT%2BKI9UFbP%2FqlItqykcQXCplIFoFkg0zNXH1zG9CBXBuOENvlcvi8cOMNfnFapwVtGgBfJktj82O%2BxSUaBmHVlzucTkRXezet8rH%2BApwO15khO0HIp6xuF2b77ngLJPiLhHUczGN&X-Amz-Signature=b7a0b9494dd3f9c787bb50f69828c103cc4c0d6b5331dcf3856f45a355483197&X-Amz-SignedHeaders=host&response-cache-control=no-cache&response-content-type=video%2Fmp4&x-amz-user-agent=aws-sdk-js%2F3.6.1%20os%2FWindows%2FNT_10.0%20lang%2Fjs%20md%2Fbrowser%2FChrome_102.0.0.0%20api%2Fs3%2F3.6.1%20aws-amplify%2F4.0.2_js&x-id=GetObject",
              likes: 0,
              state: "play",
              lastUpdated: "Updated on 2022-06-25",
              videoContent: 'play.mp4'
          },
          {
              id: "821b5047-0475-4794-a8d6-541083a7bf0c",
              title: "Purchase",
              textContent: "Campaigns to encourage subscribers to purchase a product or service.",
              mediaContent: "https://empushy-dashboard203001-staging.s3.eu-west-1.amazonaws.com/public/videos/cta_purchase.mp4?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIATK2YTNIWLOFKZC3L%2F20220627%2Feu-west-1%2Fs3%2Faws4_request&X-Amz-Date=20220627T144948Z&X-Amz-Expires=900&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEL%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEaCWV1LXdlc3QtMSJHMEUCIQDJ9C7oLFc8ITlpvlU9R5d36hWAe7kLKm7648WsWiz6xAIgNF1FS75SzbzOh6wg%2BpWzlQIy6%2B960tfzxUkRuk%2B5X8wqzQQI2P%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgwyMjk0Mjk3MDExNjQiDN%2BA5NmwVqhcWnbewCqhBLDqf%2B%2BR0f0FH%2FgjOqbyql4BiIi5D%2BSxDkzaFlfai0%2F1UHk3OjiNoVSGEhZssPE5pNEfRC8mxRy1bZpngiLTGifE1q62b29RyQYmx%2B%2Ft0g0ZIc7QmdsTmDOZ%2B%2BITQ9jnSHq0J6RmnuS2X4mjrZ4iCYbwEsitBjTiR48Z9wyeiVH5SbRhQ%2BpJQ6oXtm0nkxpqSq%2FHdV9lrjR7lH4JFFuiSQcCh6QwcGoSEypX5qjZ3Z1Q4K1hIl9C4d9BoQhaXNFOo8QP5jn%2B5ut7HyiN3stwgJMQfpLmd3luzw2UzaB3DWOa9c0E6RnD1Agc%2FIq2SZr5BmHz5X8HbvfNfAHbFEX8KbGWMxR%2BxD57HU45YiIwrVlZ7L9WAS82lJcMjc6rS7efdcfyV6Cksiut4nXVX%2BzZku98sILyg6BTzKWcvxDoybY22w0J%2B%2FTR3dKxhebLVeCVAzLaVdIBuJc0tn0uN2SyRHTzwc%2FUMmL0YtKuRXOm9kqHbwdt06LnWxapRObC1lhXJRt9j7Z0WbJKGrX51s2WCGicnvFlBJIga%2FV0X4Yh%2B32Zz3bskGNuJK1knEV4ufamGKDmB1rZXmeroOvB%2F9Y%2Fy13nSioZ8ZkL0oTpRvliivrt27UnFVGvQiAZGtvTRfCIp3494MyqgkplXmwSAqJxqkN%2Bx7zabbQ223RXqPi8nE3t7KSCxyyqS4%2B%2FWRLO2uhUbpU3w%2BmOJagHnGBGfXZ9%2Bvk%2BMIOD55UGOoUChLHCvi9gZp%2F6YfsxPhAakKtoygm%2FbjuKV3lu7fGAAV7gch3%2FxtsiN7K636NzN0HXU55a0OjPxyqH6Rq8%2BoFM4vuQhE3APIJm0gtbATKw8gTFyb8PEnCt%2FpxSY40NZW8me%2BqDx1kyVq9DXQXlnIyaX34ZPTPhYz57AisaMtoffnDb8sZl9TZw6XBGl4G8l66EzXpKI9EbDJlh4Ml%2Br1XzKT%2BKI9UFbP%2FqlItqykcQXCplIFoFkg0zNXH1zG9CBXBuOENvlcvi8cOMNfnFapwVtGgBfJktj82O%2BxSUaBmHVlzucTkRXezet8rH%2BApwO15khO0HIp6xuF2b77ngLJPiLhHUczGN&X-Amz-Signature=b04ccc045a2ee557a2bf09515bb6476d4211fa10aea54258701c3c0ffda8c0b8&X-Amz-SignedHeaders=host&response-cache-control=no-cache&response-content-type=video%2Fmp4&x-amz-user-agent=aws-sdk-js%2F3.6.1%20os%2FWindows%2FNT_10.0%20lang%2Fjs%20md%2Fbrowser%2FChrome_102.0.0.0%20api%2Fs3%2F3.6.1%20aws-amplify%2F4.0.2_js&x-id=GetObject",
              likes: 0,
              state: "purchase",
              lastUpdated: "Updated on 2022-06-25",
              videoContent: 'cta_purchase.mp4'
          },
          {
              id: "44083878-9c5c-48cc-b4fd-e45f57e7d873",
              title: "Download",
              textContent: "Campaigns to encourage subscribers to download an asset.",
              mediaContent: "https://empushy-dashboard203001-staging.s3.eu-west-1.amazonaws.com/public/videos/download.mp4?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIATK2YTNIWLOFKZC3L%2F20220627%2Feu-west-1%2Fs3%2Faws4_request&X-Amz-Date=20220627T144948Z&X-Amz-Expires=900&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEL%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEaCWV1LXdlc3QtMSJHMEUCIQDJ9C7oLFc8ITlpvlU9R5d36hWAe7kLKm7648WsWiz6xAIgNF1FS75SzbzOh6wg%2BpWzlQIy6%2B960tfzxUkRuk%2B5X8wqzQQI2P%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAAGgwyMjk0Mjk3MDExNjQiDN%2BA5NmwVqhcWnbewCqhBLDqf%2B%2BR0f0FH%2FgjOqbyql4BiIi5D%2BSxDkzaFlfai0%2F1UHk3OjiNoVSGEhZssPE5pNEfRC8mxRy1bZpngiLTGifE1q62b29RyQYmx%2B%2Ft0g0ZIc7QmdsTmDOZ%2B%2BITQ9jnSHq0J6RmnuS2X4mjrZ4iCYbwEsitBjTiR48Z9wyeiVH5SbRhQ%2BpJQ6oXtm0nkxpqSq%2FHdV9lrjR7lH4JFFuiSQcCh6QwcGoSEypX5qjZ3Z1Q4K1hIl9C4d9BoQhaXNFOo8QP5jn%2B5ut7HyiN3stwgJMQfpLmd3luzw2UzaB3DWOa9c0E6RnD1Agc%2FIq2SZr5BmHz5X8HbvfNfAHbFEX8KbGWMxR%2BxD57HU45YiIwrVlZ7L9WAS82lJcMjc6rS7efdcfyV6Cksiut4nXVX%2BzZku98sILyg6BTzKWcvxDoybY22w0J%2B%2FTR3dKxhebLVeCVAzLaVdIBuJc0tn0uN2SyRHTzwc%2FUMmL0YtKuRXOm9kqHbwdt06LnWxapRObC1lhXJRt9j7Z0WbJKGrX51s2WCGicnvFlBJIga%2FV0X4Yh%2B32Zz3bskGNuJK1knEV4ufamGKDmB1rZXmeroOvB%2F9Y%2Fy13nSioZ8ZkL0oTpRvliivrt27UnFVGvQiAZGtvTRfCIp3494MyqgkplXmwSAqJxqkN%2Bx7zabbQ223RXqPi8nE3t7KSCxyyqS4%2B%2FWRLO2uhUbpU3w%2BmOJagHnGBGfXZ9%2Bvk%2BMIOD55UGOoUChLHCvi9gZp%2F6YfsxPhAakKtoygm%2FbjuKV3lu7fGAAV7gch3%2FxtsiN7K636NzN0HXU55a0OjPxyqH6Rq8%2BoFM4vuQhE3APIJm0gtbATKw8gTFyb8PEnCt%2FpxSY40NZW8me%2BqDx1kyVq9DXQXlnIyaX34ZPTPhYz57AisaMtoffnDb8sZl9TZw6XBGl4G8l66EzXpKI9EbDJlh4Ml%2Br1XzKT%2BKI9UFbP%2FqlItqykcQXCplIFoFkg0zNXH1zG9CBXBuOENvlcvi8cOMNfnFapwVtGgBfJktj82O%2BxSUaBmHVlzucTkRXezet8rH%2BApwO15khO0HIp6xuF2b77ngLJPiLhHUczGN&X-Amz-Signature=8fff3a25985ebda9f4fc1f243b66f3982afacb8a6255360f7f71f7d709140714&X-Amz-SignedHeaders=host&response-cache-control=no-cache&response-content-type=video%2Fmp4&x-amz-user-agent=aws-sdk-js%2F3.6.1%20os%2FWindows%2FNT_10.0%20lang%2Fjs%20md%2Fbrowser%2FChrome_102.0.0.0%20api%2Fs3%2F3.6.1%20aws-amplify%2F4.0.2_js&x-id=GetObject",
              likes: 0,
              state: "download",
              lastUpdated: "Updated on 2022-06-25",
              videoContent: 'download.mp4'
            }
        ]
    for(var card of cardList){
        card.videoContent = await Storage.get('videos/'+card.videoContent,
              { level: 'public', download: false, cacheControl: 'no-cache', contentType: 'video/mp4' })
    }
    setCallToActionCards(cardList.map((item) => {
      return (
          <CallToActionCard
              key={item.id}
              id={item.id}
              title={item.title}
              textContent={item.textContent}
              mediaContent={item.videoContent}
              likes={item.likes}
              state={item.state}
              updateContentState={updateCTAState}
              lastUpdated={dateToString(item.updatedOn)}
              cardLiked={cardLiked}
          />
      );
    }))
  }

  function updateCTAState(newCTAState){

    setCTAState(newCTAState)
    if(newCTAState.hasOwnProperty('title')) {


      setTrendData({})
      setTopMarkets([])
      setCampaigns([])
      setHeatmapData([])
      setEmotions([])
      setTones([])

      fetchTrendFreq(newCTAState)
      fetchTopMarkets(newCTAState)
      fetchCampaigns(newCTAState)
      fetchEmotions(newCTAState)
      fetchTones(newCTAState)
      fetchHeatmap(newCTAState)
    }
  }

  function updateContentState(newState){

    if(newState==='live-campaigns' || newState==='home' || newState==='call-to-actions'
        || newState==='purchase'){
      setContentState(newState)
    } else {
      setAlertModalState({title: 'Sign up or Sign in', message: 'To access this feature you need to sign up or sign in. ' +
            'As we are currently in Beta, it is free to do so 🎉 No payment or card details required. Just let us know what ' +
            'you think of the platform 🙏 Click the button in the header to access ☝️ '})
      //history.push('/signin')
    }
  }

  async function cardLiked(id, likes){

  }

  async function fetchHeatmap(cta) {
    const apiName = 'DashboardAPI';
    const path = '/emulator/query-open-access';
    const params = {
      queryStringParameters: {
        case: 'call-to-actions-heatmap',
        val: cta.state
      }
    };

    API
        .get(apiName, path, params)
        .then(async(response) => {
          if('heatmap' in response){
            setHeatmapData(response['heatmap'])
          }
          else{
            console.log('Heatmap data not found.')
          }
        })
        .catch(error => {
          console.log('Error executing request.')
          console.log(error)
        });
  }

  async function fetchTrendFreq(cta){
    const apiName = 'DashboardAPI';
    const path = '/emulator/query-open-access';
    const params = {
      queryStringParameters: {
        case: 'call-to-actions-freq',
        val: cta.state
      }
    };
    API
        .get(apiName, path, params)
        .then(async(response) => {

          if('freq' in response){
            setTrendData(response['freq'])
          }
        })
        .catch(error => {
          console.log('Error executing request.')
          console.log(error)
        });

  }

  async function fetchTopMarkets(cta){
    const apiName = 'DashboardAPI';
    const path = '/emulator/query-open-access';
    const params = {
      queryStringParameters: {
        case: 'call-to-actions-top-market',
        val: cta.state
      }
    };
    API
        .get(apiName, path, params)
        .then(async(response) => {

          if('top' in response){
            setTopMarkets(response['top'])
          }
          else{
            console.log('Top data not found.')
          }
        })
        .catch(error => {
          console.log('Error executing request.')
          console.log(error)
        });
  }

  async function fetchCampaigns(cta){
    const apiName = 'DashboardAPI';
    const path = '/emulator/query-open-access';
    const params = {
      queryStringParameters: {
        case: 'call-to-actions-campaigns',
        val: cta.state
      }
    };
    API
        .get(apiName, path, params)
        .then(async(response) => {

          if('campaigns' in response){
            setCampaigns(response['campaigns'])
          }
          else{
            console.log('Top data not found.')
          }
        })
        .catch(error => {
          console.log('Error executing request.')
          console.log(error)
        });
  }

  async function fetchEmotions(cta){
    const apiName = 'DashboardAPI';
    const path = '/emulator/query-open-access';
    const params = {
      queryStringParameters: {
        case: 'call-to-actions-emotions',
        val: cta.state
      }
    };
    API
        .get(apiName, path, params)
        .then(async(response) => {
          if('top' in response){
            setEmotions(response['top'])
          }
          else{
            console.log('Top data not found.')
          }
        })
        .catch(error => {
          console.log('Error executing request.')
          console.log(error)
        });
  }

  async function fetchTones(cta){
    const apiName = 'DashboardAPI';
    const path = '/emulator/query-open-access';
    const params = {
      queryStringParameters: {
        case: 'call-to-actions-tones',
        val: cta.state
      }
    };
    API
        .get(apiName, path, params)
        .then(async(response) => {
          if('top' in response){
            setTones(response['top'])
          }
          else{
            console.log('Top data not found.')
          }
        })
        .catch(error => {
          console.log('Error executing request.')
          console.log(error)
        });
  }

  function filterAssociatedNotifs(filter, val){

  }

    // close on click outside
    useEffect(() => {
        const clickHandler = ({ target }) => {
            if (!sidebar.current || !trigger.current) return;
            if (!sidebarOpen || sidebar.current.contains(target) || trigger.current.contains(target)) return;
            setSidebarOpen(false);
        };
        document.addEventListener('click', clickHandler);
        return () => document.removeEventListener('click', clickHandler);
    });

    // close if the esc key is pressed
    useEffect(() => {
        const keyHandler = ({ keyCode }) => {
            if (!sidebarOpen || keyCode !== 27) return;
            setSidebarOpen(false);
        };
        document.addEventListener('keydown', keyHandler);
        return () => document.removeEventListener('keydown', keyHandler);
    });

  return (
      <div className="flex h-screen overflow-hidden striped-background-pattern">
        {/* Page Title */}
        <Helmet>
          <title>EmPushy | Landing</title>
        </Helmet>

        {/* Sidebar */}
        <div className="lg:w-64">
          {/* Sidebar backdrop (mobile only) */}
          <div className={`fixed inset-0 bg-gray-900 bg-opacity-30 z-40 lg:hidden lg:z-auto transition-opacity duration-200 ${sidebarOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'}`} aria-hidden="true"></div>

          {/* Sidebar */}
          <div
              id="sidebar"
              ref={sidebar}
              className={`absolute z-40 left-0 top-0 lg:static lg:left-auto lg:top-auto lg:translate-x-0 transform h-screen overflow-y-scroll lg:overflow-y-auto no-scrollbar w-64 flex-shrink-0 bg-gray-800 p-4 transition-transform duration-200 ease-in-out ${sidebarOpen ? 'translate-x-0' : '-translate-x-64'}`}
          >

            {/* Sidebar header */}
            <div className="flex justify-between mb-10 pr-3 sm:px-2">
                {/* Close button */}
                <button
                    ref={trigger}
                    className="lg:hidden text-gray-500 hover:text-gray-400"
                    onClick={() => setSidebarOpen(!sidebarOpen)}
                    aria-controls="sidebar"
                    aria-expanded={sidebarOpen}>
                    <span className="sr-only">Close sidebar</span>
                    <svg className="w-6 h-6 fill-current" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10.7 18.7l1.4-1.4L7.8 13H20v-2H7.8l4.3-4.3-1.4-1.4L4 12z" />
                    </svg>
                </button>
              {/* Logo */}
              <NavLink exact to="/" className="block">
                <img  src={EmPushyLogo} width="150" height="150" viewBox="0 0 150 150" alt="Logo" />
              </NavLink>
            </div>

            {/* Links */}
            <div>
              <h3 className="text-xs uppercase text-gray-500 font-semibold pl-3">Pages</h3>
              <ul className="mt-3">
                {/* Dashboard */}
                <li className={`px-3 py-2 rounded-sm mb-0.5 last:mb-0`}>
                  <div onClick={()=>updateContentState('home')} className={`cursor-pointer 
                  block text-gray-200 hover:text-white transition duration-150
                    ${contentState === 'home' && 'hover:text-gray-200' && 'text-yellow-300'}`}>
                    <div className="flex flex-grow">
                      <svg className={`flex-shrink-0 h-6 w-6 mr-3 ${contentState === 'home' && 'text-yellow-300'}`} viewBox="0 0 24 24">
                        <path className={`fill-current text-gray-400 ${contentState === 'home' && 'text-yellow-300'}`} d="M12 0C5.383 0 0 5.383 0 12s5.383 12 12 12 12-5.383 12-12S18.617 0 12 0z" />
                        <path className={`fill-current text-gray-400 ${contentState === 'home' && 'text-yellow-300'}'}`} d="M12 3c-4.963 0-9 4.037-9 9s4.037 9 9 9 9-4.037 9-9-4.037-9-9-9z" />
                        <path className={`fill-current text-gray-100 ${contentState === 'home' && 'text-yellow-300'}`} d="M12 15c-1.654 0-3-1.346-3-3 0-.462.113-.894.3-1.285L6 6l4.714 3.301A2.973 2.973 0 0112 9c1.654 0 3 1.346 3 3s-1.346 3-3 3z" />
                      </svg>
                      <span className="text-sm font-medium">Dashboard</span>
                    </div>
                  </div>
                </li>
                {/* Call-to-actions */}
                <li className={`px-3 py-2 rounded-sm mb-0.5 last:mb-0`}>
                  <div onClick={()=>updateContentState('call-to-actions')} className={`cursor-pointer 
                  block text-gray-200 hover:text-white transition duration-150
                    ${contentState === 'call-to-actions' && 'hover:text-gray-200' && 'text-yellow-300'}`}>
                    <div className="flex flex-grow">
                      <svg xmlns="http://www.w3.org/2000/svg" className={`flex-shrink-0 h-6 w-6 mr-3
                      icon icon-tabler icon-tabler-hand-click  ${contentState === 'call-to-actions' && 'text-yellow-300'}`}
                           width="44" height="44" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor"
                           fill="none" strokeLinecap="round" strokeLinejoin="round">
                        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                        <path d="M8 13v-8.5a1.5 1.5 0 0 1 3 0v7.5"/>
                        <path d="M11 11.5v-2a1.5 1.5 0 0 1 3 0v2.5"/>
                        <path d="M14 10.5a1.5 1.5 0 0 1 3 0v1.5"/>
                        <path
                            d="M17 11.5a1.5 1.5 0 0 1 3 0v4.5a6 6 0 0 1 -6 6h-2h.208a6 6 0 0 1 -5.012 -2.7l-.196 -.3c-.312 -.479 -1.407 -2.388 -3.286 -5.728a1.5 1.5 0 0 1 .536 -2.022a1.867 1.867 0 0 1 2.28 .28l1.47 1.47"/>
                        <path d="M5 3l-1 -1"/>
                        <path d="M4 7h-1"/>
                        <path d="M14 3l1 -1"/>
                        <path d="M15 6h1"/>
                      </svg>
                      <span className="text-sm font-medium">Call-to-actions</span>
                    </div>
                  </div>
                </li>
                {/* Integrations */}
                <li className={`px-3 py-2 rounded-sm mb-0.5 last:mb-0`}>
                  <NavLink exact to={{pathname: "/signin"}} className={`block text-gray-200 hover:text-yellow-300 transition duration-150`}>
                    <div className="flex flex-grow">
                      <svg className="flex-shrink-0 h-6 w-6 mr-3" viewBox="0 0 24 24">
                        <circle className={`fill-current text-gray-400 `} cx="18.5" cy="5.5" r="4.5" />
                        <circle className={`fill-current text-gray-600`} cx="5.5" cy="5.5" r="4.5" />
                        <circle className={`fill-current text-gray-600`} cx="18.5" cy="18.5" r="4.5" />
                        <circle className={`fill-current text-gray-400`} cx="5.5" cy="18.5" r="4.5" />
                      </svg>
                      <span className="text-sm font-medium">Integrations</span>
                    </div>
                  </NavLink>
                </li>
                {/* Compose */}
                <li className={`px-3 py-2 rounded-sm mb-0.5 last:mb-0`}>
                  <NavLink exact to={{pathname: "/signin"}} className={`block text-gray-200 hover:text-yellow-400 transition duration-150`}>
                    <div className="flex flex-grow">
                      <svg className="flex-shrink-0 h-6 w-6 mr-3" viewBox="0 0 24 24">
                        <path className={`fill-current text-gray-600`} d="M14.5 7c4.695 0 8.5 3.184 8.5 7.111 0 1.597-.638 3.067-1.7 4.253V23l-4.108-2.148a10 10 0 01-2.692.37c-4.695 0-8.5-3.184-8.5-7.11C6 10.183 9.805 7 14.5 7z" />
                        <path className={`fill-current text-gray-400`} d="M11 1C5.477 1 1 4.582 1 9c0 1.797.75 3.45 2 4.785V19l4.833-2.416C8.829 16.85 9.892 17 11 17c5.523 0 10-3.582 10-8s-4.477-8-10-8z" />
                      </svg>
                      <span className="text-sm font-medium">Compose</span>
                    </div>
                  </NavLink>
                </li>
                {/* Campaign Templates */}
                <li className={`px-3 py-2 rounded-sm mb-0.5 last:mb-0`}>
                  <NavLink exact to={{pathname: "/signin"}} className={`block text-gray-200 hover:text-yellow-300 transition duration-150`}>
                    <div className="flex flex-grow">

                      <svg xmlns="http://www.w3.org/2000/svg" className="flex-shrink-0 h-6 w-6 mr-3
                      icon icon-tabler icon-tabler-notes text-grey-400" width="44"
                           height="44" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" fill="none"
                           strokeLinecap="round" strokeLinejoin="round">
                        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                        <rect className={`text-gray-400`} x="5" y="3" width="14" height="18" rx="2"/>
                        <line className={`fill-current text-gray-400`} x1="9" y1="7" x2="15" y2="7"/>
                        <line className={`fill-current text-gray-400`} x1="9" y1="11" x2="15" y2="11"/>
                        <line className={`fill-current text-gray-400`} x1="9" y1="15" x2="13" y2="15"/>
                      </svg>
                      <span className="text-sm font-medium">Campaign Templates</span>
                    </div>
                  </NavLink>
                </li>
                {/* Marketing Experts */}
                <li className={`px-3 py-2 rounded-sm mb-0.5 last:mb-0`}>
                  <NavLink exact to={{pathname: "/signin"}} className={`block text-gray-200 hover:text-yellow-300 transition duration-150`}>
                    <div className="flex flex-grow">
                      <svg xmlns="http://www.w3.org/2000/svg" className="flex-shrink-0 h-6 w-7 mr-2 text-grey-400
                      icon icon-tabler icon-tabler-user-check"
                           viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor"
                           fill="none" strokeLinecap="round" strokeLinejoin="round">
                        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                        <circle className={`text-gray-400`} cx="9" cy="7" r="4"/>
                        <path className={`text-gray-400`} d="M3 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2"/>
                        <path className={`text-gray-400`} d="M16 11l2 2l4 -4"/>
                      </svg>
                      <span className="text-sm font-medium">Insights from Experts</span>
                    </div>
                  </NavLink>
                </li>
                {/* WebPush */}
                <li className={`px-3 py-2 rounded-sm mb-0.5 last:mb-0`}>
                  <NavLink exact to={{pathname: "/signin"}} className={`block text-gray-200 hover:text-yellow-400 transition duration-150`}>
                    <div className="flex flex-grow">
                      {/*<svg className="flex-shrink-0 h-6 w-6 mr-3" viewBox="0 0 24 24">
                    <path className={`fill-current text-gray-600 ${page === 'webpush' && 'text-pink-500'}`} d="M14.5 7c4.695 0 8.5 3.184 8.5 7.111 0 1.597-.638 3.067-1.7 4.253V23l-4.108-2.148a10 10 0 01-2.692.37c-4.695 0-8.5-3.184-8.5-7.11C6 10.183 9.805 7 14.5 7z" />
                    <path className={`fill-current text-gray-400 ${page === 'webpush' && 'text-yellow-300'}`} d="M11 1C5.477 1 1 4.582 1 9c0 1.797.75 3.45 2 4.785V19l4.833-2.416C8.829 16.85 9.892 17 11 17c5.523 0 10-3.582 10-8s-4.477-8-10-8z" />
                  </svg>*/}
                      <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-mail-forward  h-7 w-7 mr-2"
                           viewBox="0 0 24 24" >
                        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                        <path className={`fill-current text-gray-600`} d="M12 18h-7a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v7.5"/>
                        <path strokeWidth="1" stroke="#94a3b8" fill="none"
                              strokeLinejoin="round" d="M3 6l9 6l9 -6"/>
                        <path strokeWidth="1" stroke="#94a3b8" fill="none"
                              strokeLinejoin="round" d="M15 18h6"/>
                        <path stroke="#94a3b8" fill="#94a3b8" d="M18 15l3 3l-3 3"/>
                      </svg>
                      <span className="text-sm font-medium">Web Push</span>
                    </div>
                  </NavLink>
                </li>
                {/* API */}
                <li className={`px-3 py-2 rounded-sm mb-0.5 last:mb-0`}>
                  <NavLink exact to={{pathname: "/signin"}} className={`block text-gray-200 hover:text-yellow-400 transition duration-150`}>
                    <div className="flex flex-grow">
                      {/*<svg className="flex-shrink-0 h-6 w-6 mr-3" viewBox="0 0 24 24">
                    <path className={`fill-current text-gray-600 ${page === 'webpush' && 'text-pink-500'}`} d="M14.5 7c4.695 0 8.5 3.184 8.5 7.111 0 1.597-.638 3.067-1.7 4.253V23l-4.108-2.148a10 10 0 01-2.692.37c-4.695 0-8.5-3.184-8.5-7.11C6 10.183 9.805 7 14.5 7z" />
                    <path className={`fill-current text-gray-400 ${page === 'webpush' && 'text-yellow-300'}`} d="M11 1C5.477 1 1 4.582 1 9c0 1.797.75 3.45 2 4.785V19l4.833-2.416C8.829 16.85 9.892 17 11 17c5.523 0 10-3.582 10-8s-4.477-8-10-8z" />
                  </svg>*/}
                      <svg xmlns="http://www.w3.org/2000/svg" className="flex-shrink-0 h-6 w-6 mr-3 text-grey-400
                      icon icon-tabler icon-tabler-cloud" width="52"
                           height="52" viewBox="0 0 24 24" strokeWidth="1.5" stroke="#2c3e50" fill="none"
                           strokeLinecap="round" strokeLinejoin="round">
                        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                        <path className={`fill-current text-gray-400`} d="M7 18a4.6 4.4 0 0 1 0 -9a5 4.5 0 0 1 11 2h1a3.5 3.5 0 0 1 0 7h-12"/>
                      </svg>
                      <span className="text-sm font-medium">EmPushy API</span>
                    </div>
                  </NavLink>
                </li>
                {/* Android SDK */}
                <li className={`px-3 py-2 rounded-sm mb-0.5 last:mb-0`}>
                  <NavLink exact to={{pathname: "/signin"}} className={`block text-gray-200 hover:text-yellow-400 transition duration-150`}>
                    <div className="flex flex-grow">
                      <svg xmlns="http://www.w3.org/2000/svg" className="flex-shrink-0 h-6 w-6 mr-3 text-grey-400
                      icon icon-tabler icon-tabler-code" width="52"
                           height="52" viewBox="0 0 24 24" strokeWidth="1.5" stroke="#94a3b8" fill="none"
                           strokeLinecap="round" strokeLinejoin="round">
                        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                        <polyline points="7 8 3 12 7 16"/>
                        <polyline points="17 8 21 12 17 16"/>
                        <line x1="14" y1="4" x2="10" y2="20"/>
                      </svg>
                      <span className="text-sm font-medium">Mobile SDK</span>
                    </div>
                  </NavLink>
                </li>
                {/* EmPushy Mobile App */}
                <li className={`px-3 py-2 rounded-sm mb-0.5 last:mb-0`}>
                  <NavLink exact to={{pathname: "/signin"}} className={`block text-gray-200 hover:text-yellow-400 transition duration-150`}>
                    <div className="flex flex-grow">
                      <svg xmlns="http://www.w3.org/2000/svg" className="flex-shrink-0 h-6 w-6 mr-3
                      icon icon-tabler icon-tabler-device-mobile"
                           width="52" height="52" viewBox="0 0 24 24" strokeWidth="1.5" stroke="#94a3b8" fill="none"
                           strokeLinecap="round" strokeLinejoin="round">
                        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                        <rect x="7" y="4" width="10" height="16" rx="1"/>
                        <line x1="11" y1="5" x2="13" y2="5"/>
                        <line x1="12" y1="17" x2="12" y2="17.01"/>
                      </svg>
                      <span className="text-sm font-medium">Android App</span>
                    </div>
                  </NavLink>
                </li>
                {/* Smart Home */}
                <li className={`px-3 py-2 rounded-sm mb-0.5 last:mb-0`}>
                  <NavLink exact to={{pathname: "/signin"}} className={`block text-gray-200 hover:text-yellow-400 transition duration-150`}>
                    <div className="flex flex-grow">
                      <svg xmlns="http://www.w3.org/2000/svg" className="flex-shrink-0 h-6 w-6 mr-3 text-grey-400
                      icon icon-tabler icon-tabler-device-speaker"
                           width="52" height="52" viewBox="0 0 24 24" strokeWidth="1.5" stroke="#94a3b8" fill="none"
                           strokeLinecap="round" strokeLinejoin="round">
                        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                        <rect x="5" y="3" width="14" height="18" rx="2"/>
                        <circle cx="12" cy="14" r="3"/>
                        <line x1="12" y1="7" x2="12" y2="7.01"/>
                      </svg>
                      <span className="text-sm font-medium">Alexa Skill</span>
                    </div>
                  </NavLink>
                </li>
                {/* Docs & Guides */}
                <li className={`px-3 py-2 rounded-sm mb-0.5 last:mb-0`}>
                  <NavLink exact to={{pathname: "/signin"}} className={`block text-gray-200 hover:text-yellow-400 transition duration-150`}>
                    <div className="flex flex-grow">
                      <svg xmlns="http://www.w3.org/2000/svg" className="flex-shrink-0 h-6 w-6 mr-3 text-grey-400
                      icon icon-tabler icon-tabler-clipboard-list"
                           width="56" height="56" viewBox="0 0 24 24" strokeWidth="1.5" stroke="#2c3e50" fill="none"
                           strokeLinecap="round" strokeLinejoin="round">
                        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                        <path className={`fill-current text-gray-400`} d="M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2"/>
                        <rect className={`fill-current text-gray-500`} x="9" y="3" width="6" height="4" rx="2"/>
                        <line className={`fill-current text-gray-600`} x1="9" y1="12" x2="9.01" y2="12"/>
                        <line className={`fill-current text-gray-600`} x1="13" y1="12" x2="15" y2="12"/>
                        <line className={`fill-current text-gray-600`} x1="9" y1="16" x2="9.01" y2="16"/>
                        <line className={`fill-current text-gray-600`} x1="13" y1="16" x2="15" y2="16"/>
                      </svg>
                      <span className="text-sm font-medium">Docs & Guides</span>
                    </div>
                  </NavLink>
                </li>
              </ul>
            </div>

          </div>
        </div>

        {/* Content area */}
        <div className="relative flex flex-col flex-1 overflow-y-auto overflow-x-hidden">

          {/*  Site header */}
          <header className="sticky top-0 bg-yellow-300 z-30 shadow-md rounded-sm border border-gray-200">
            <div className="px-4 sm:px-6 lg:px-8">
              <div className="flex items-center justify-between h-16 -mb-px">

                {/* Header: Left side */}
                <div className="flex">

                  {/* Hamburger button */}
                  <button
                      className="text-white hover:text-pink-400 lg:hidden"
                      aria-controls="sidebar"
                      aria-expanded={sidebarOpen}
                      onClick={() => setSidebarOpen(!sidebarOpen)}>
                    <span className="sr-only">Open sidebar</span>
                    <svg className="w-6 h-6 fill-current" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <rect x="4" y="5" width="16" height="2" />
                      <rect x="4" y="11" width="16" height="2" />
                      <rect x="4" y="17" width="16" height="2" />
                    </svg>
                  </button>

                </div>

                {/* Header: Right side */}
                <div className="flex items-center">
                  <button
                      className="btn bg-pink-500 text-white hover:bg-pink-700"
                      onClick={() =>
                          history.push('/signin')
                      }>
                    Free Full Access 😇
                  </button>
                </div>

              </div>
            </div>
          </header>


          <main>

            {
              contentState=='home'?
                  <div>
                    <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">

                      {/* Page header */}
                      <div className="sm:flex sm:justify-between sm:items-center mb-5">

                        {/* Left: Title */}
                        <div className="mb-4 sm:mb-0">
                          <h1 className="text-2xl md:text-3xl text-slate-800 font-bold">Level up your Engagement ✨</h1>
                        </div>

                        {/* Right: Actions */}
                        <div className="grid grid-flow-col sm:auto-cols-max justify-start sm:justify-end gap-2">

                          {/* Add meetup button */}
                          {/*<button className="btn bg-indigo-500 hover:bg-indigo-600 text-white">
                      <svg className="w-4 h-4 fill-current opacity-50 shrink-0" viewBox="0 0 16 16">
                        <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z" />
                      </svg>
                      <span className="hidden xs:block ml-2">Feedback</span>
                    </button>*/}

                        </div>

                      </div>

                      {/* Filters */}
                      {/*<div className="mb-5">
                  <ul className="flex flex-wrap -m-1">
                    <li key="1" className="m-1">
                      <button className="inline-flex items-center justify-center text-sm font-medium leading-5 rounded-full px-3 py-1 border border-transparent shadow-sm bg-pink-500 text-white duration-150 ease-in-out">
                        View All
                      </button>
                    </li>
                    <li key="2" className="m-1">
                      <button className="inline-flex items-center justify-center text-sm font-medium leading-5 rounded-full px-3 py-1 border border-slate-200 hover:border-slate-300 shadow-sm bg-white text-slate-500 duration-150 ease-in-out">
                        Scheduling
                      </button>
                    </li>
                    <li key="3" className="m-1">
                      <button className="inline-flex items-center justify-center text-sm font-medium leading-5 rounded-full px-3 py-1 border border-slate-200 hover:border-slate-300 shadow-sm bg-white text-slate-500 duration-150 ease-in-out">
                        Content
                      </button>
                    </li>
                    <li key="4" className="m-1">
                      <button className="inline-flex items-center justify-center text-sm font-medium leading-5 rounded-full px-3 py-1 border border-slate-200 hover:border-slate-300 shadow-sm bg-white text-slate-500 duration-150 ease-in-out">
                        Automation
                      </button>
                    </li>
                    <li key="5" className="m-1">
                      <button className="inline-flex items-center justify-center text-sm font-medium leading-5 rounded-full px-3 py-1 border border-slate-200 hover:border-slate-300 shadow-sm bg-white text-slate-500 duration-150 ease-in-out">
                        Trends
                      </button>
                    </li>
                    <li key="6" className="m-1">
                      <button className="inline-flex items-center justify-center text-sm font-medium leading-5 rounded-full px-3 py-1 border border-slate-200 hover:border-slate-300 shadow-sm bg-white text-slate-500 duration-150 ease-in-out">
                        Templates
                      </button>
                    </li>
                  </ul>
                </div>*/}

                      {/* Content */}
                      {cards}

                      {/*<DashboardCards updateContentState={updateContentState}/>*/}

                    </div>
                    <hr/>
                    {/* Article 1 */}
                    <div className="px-4 sm:px-6 lg:px-8 py-3 w-full">
                      {/* Page content */}
                      <div className="max-w-5xl mx-auto flex flex-col lg:flex-row lg:space-x-8 xl:space-x-16">
                        <div>
                          <div className="text-sm font-semibold text-pink-500 uppercase mb-2">Sat 07 May, 2022 - 8:40 PM</div>
                          <header className="mb-4">
                            {/* Title */}
                            <h1 className="text-2xl md:text-3xl text-slate-800 font-bold mb-2">To Engage Or Not To Engage, That Is The Question</h1>
                            <p>Some audiences expect you to engage with them more often than others. There are a lot of factors
                              which contribute to calculating the right amount of engagement. One of the most important factors
                              is the type of market vertical you are associated with.</p>
                          </header>

                          {/* Meta */}
                          <div className="space-y-3 sm:flex sm:items-center sm:justify-between sm:space-y-0 mb-6">
                            {/* Author */}
                            <div className="flex items-center sm:mr-4">
                              <div className="block mr-2 shrink-0">
                                <img className="rounded-full" src={UserImage07} width="32" height="32" alt="User 04" />
                              </div>
                              <div className="text-sm whitespace-nowrap">
                                Posted by{' '}
                                <strong className="font-semibold text-slate-800">
                                  Kieran
                                </strong>
                              </div>
                            </div>
                            {/* Right side */}
                            <div className="flex flex-wrap items-center sm:justify-end space-x-2">
                              {/* Tags */}
                              <a href={Slide01} download="empushy_insight.png"
                                 className="hover:bg-pink-400 hover:text-white text-xs inline-flex items-center font-medium bg-white text-slate-600 rounded-full text-center px-2.5 py-1">
                                {/*<svg className="w-4 h-3 fill-slate-400 mr-2" viewBox="0 0 16 12">
                            <path d="m16 2-4 2.4V2a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V7.6l4 2.4V2ZM2 10V2h8v8H2Z" />
                          </svg>*/}
                                <svg className="icon icon-tabler icon-tabler-cloud-download w-5 h-5 fill-slate-400 mr-2"
                                     width="44" height="44" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor"
                                     fill="none" strokeLinecap="round" strokeLinejoin="round">
                                  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                                  <path d="M19 18a3.5 3.5 0 0 0 0 -7h-1a5 4.5 0 0 0 -11 -2a4.6 4.4 0 0 0 -2.1 8.4"/>
                                  <line x1="12" y1="13" x2="12" y2="22"/>
                                  <polyline points="9 19 12 22 15 19"/>
                                </svg>
                                <span>Free Download</span>
                              </a>
                            </div>
                          </div>

                          {/* Image */}
                          <figure className="mb-6">
                            <img className="w-2/3 rounded-sm m-auto" src={Slide01} width="640" height="360" alt="Meetup" />
                          </figure>

                          {/* Post content */}
                          <div className="text-justify">
                            <h2 className="text-xl leading-snug text-slate-800 font-bold mb-2">Key Insights</h2>
                            <p className="mb-6">Finding just the right amount of engagement with your followers can be tricky.
                              You don't want to push too much content at them for fear of annoying them. You also don't want to
                              push too little for fear they will develop FOMO, or worse, forget about you completely. It's clear
                              from the data above that some markets push more content than others. But what is crucial to understand
                              here is that the audiences of these markets differ greatly. People who subscribe to "News & Magazines"
                              will expect to receive plenty of new content on a weekly or daily basis, as news content changes quickly.
                              However, other markets, such as "Lifestyle" or "Beauty" don't have the same turnover of new content
                              and so subscribers may not wish to hear from you as frequently. Pushing too much when your subscribers
                              don't expect or want a lot of engagement will cause annoyance and ultimately reduce the trust they
                              have in you as a brand.</p>
                            <p>So use the EmPushy platform to learn what amount and frequency of engagement your particular
                              type of audience expects. Pushing with empathy enhances their trust in you and encourages
                              healthier, happier relationships with your followers!</p>
                          </div>
                          <hr className="my-6 border-t border-slate-200" />

                        </div>
                      </div>
                    </div>

                    {/* Article 2 */}
                    <div className="px-4 sm:px-6 lg:px-8 py-8 w-full">
                      {/* Page content */}
                      <div className="max-w-5xl mx-auto flex flex-col lg:flex-row lg:space-x-8 xl:space-x-16">
                        <div>
                          <div className="text-sm font-semibold text-pink-500 uppercase mb-2">Fri 06 May, 2022 - 6:22 PM</div>
                          <header className="mb-4">
                            {/* Title */}
                            <h1 className="text-2xl md:text-3xl text-slate-800 font-bold mb-2">Connect With Empathy and Emotion</h1>
                            <p>Your subscribers don't want to interact with a machine - they want to feel important, they want to
                              feel valued, they want to feel like you're communicating directly with them, and no one else matters.
                              Through emotive text you can connect better with your followers. Be sure to use the right emotion for
                              the moment!</p>
                          </header>

                          {/* Meta */}
                          <div className="space-y-3 sm:flex sm:items-center sm:justify-between sm:space-y-0 mb-6">
                            {/* Author */}
                            <div className="flex items-center sm:mr-4">
                              <a className="block mr-2 shrink-0" href="#0">
                                <img className="rounded-full" src={UserImage07} width="32" height="32" alt="User 04" />
                              </a>
                              <div className="text-sm whitespace-nowrap">
                                Posted by{' '}
                                <strong className="font-semibold text-slate-800">
                                  Kieran
                                </strong>
                              </div>
                            </div>
                            {/* Right side */}
                            <div className="flex flex-wrap items-center sm:justify-end space-x-2">
                              {/* Tags */}
                              <a href={Slide02} download="empushy_insight.png"
                                 className="hover:bg-pink-400 hover:text-white text-xs inline-flex items-center font-medium bg-white text-slate-600 rounded-full text-center px-2.5 py-1">
                                {/*<svg className="w-4 h-3 fill-slate-400 mr-2" viewBox="0 0 16 12">
                            <path d="m16 2-4 2.4V2a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V7.6l4 2.4V2ZM2 10V2h8v8H2Z" />
                          </svg>*/}
                                <svg className="icon icon-tabler icon-tabler-cloud-download w-5 h-5 fill-slate-400 mr-2"
                                     width="44" height="44" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor"
                                     fill="none" strokeLinecap="round" strokeLinejoin="round">
                                  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                                  <path d="M19 18a3.5 3.5 0 0 0 0 -7h-1a5 4.5 0 0 0 -11 -2a4.6 4.4 0 0 0 -2.1 8.4"/>
                                  <line x1="12" y1="13" x2="12" y2="22"/>
                                  <polyline points="9 19 12 22 15 19"/>
                                </svg>
                                <span>Free Download</span>
                              </a>
                            </div>
                          </div>

                          {/* Image */}
                          <figure className="mb-6">
                            <img className="w-2/3 rounded-sm m-auto" src={Slide02} width="640" height="360" alt="Meetup" />
                          </figure>

                          {/* Post content */}
                          <div className="text-justify">
                            <h2 className="text-xl leading-snug text-slate-800 font-bold mb-2">Key Insights</h2>
                            <p className="mb-6">Emotions are powerful. They inspire, comfort, teach and convey our true intentions.
                              Paired with the content with push to subscribers they can be a powerful tool to attract attention and
                              delight an audience. Used poorly however, they can be seen to be manipulative and subscribers will be wary
                              of trusting you and your brand again. Positive emotions like <i>Excitement</i> and <i>Joy</i> have been
                              shown to elicit positive responses.</p>
                            <p>So use the EmPushy platform to learn what emotional content your particular
                              type of audience expects. Pushing with empathy enhances their trust in you and encourages
                              healthier, happier relationships with your followers!</p>
                          </div>
                          <hr className="my-6 border-t border-slate-200" />

                        </div>
                      </div>
                    </div>

                    {/* Article 3 */}
                    <div className="px-4 sm:px-6 lg:px-8 py-8 w-full">
                      {/* Page content */}
                      <div className="max-w-5xl mx-auto flex flex-col lg:flex-row lg:space-x-8 xl:space-x-16">
                        <div>
                          <div className="text-sm font-semibold text-pink-500 uppercase mb-2">Thur 05 May, 2022 - 3:15 PM</div>
                          <header className="mb-4">
                            {/* Title */}
                            <h1 className="text-2xl md:text-3xl text-slate-800 font-bold mb-2">Stand Out From The Crowd</h1>
                            <p>You need to remember that your followers are also interested in other brands aside from yours.
                              While they may think your brand is great and really value its contribution to their lives, they also have
                              other brands that they hold in equal esteem. Those brands will also be engaging them with content! So
                              how do you stand out? Even more importantly, how do you ensure you are not annoying them
                              if they have already received 10 updates from other brands in the last hour?
                            </p>
                          </header>

                          {/* Meta */}
                          <div className="space-y-3 sm:flex sm:items-center sm:justify-between sm:space-y-0 mb-6">
                            {/* Author */}
                            <div className="flex items-center sm:mr-4">
                              <a className="block mr-2 shrink-0" href="#0">
                                <img className="rounded-full" src={UserImage07} width="32" height="32" alt="User 04" />
                              </a>
                              <div className="text-sm whitespace-nowrap">
                                Posted by{' '}
                                <strong className="font-semibold text-slate-800">
                                  Kieran
                                </strong>
                              </div>
                            </div>
                            {/* Right side */}
                            <div className="flex flex-wrap items-center sm:justify-end space-x-2">
                              {/* Tags */}
                              <a href={Slide03} download="empushy_insight.png"
                                 className="hover:bg-pink-400 hover:text-white text-xs inline-flex items-center font-medium bg-white text-slate-600 rounded-full text-center px-2.5 py-1">
                                {/*<svg className="w-4 h-3 fill-slate-400 mr-2" viewBox="0 0 16 12">
                            <path d="m16 2-4 2.4V2a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V7.6l4 2.4V2ZM2 10V2h8v8H2Z" />
                          </svg>*/}
                                <svg className="icon icon-tabler icon-tabler-cloud-download w-5 h-5 fill-slate-400 mr-2"
                                     width="44" height="44" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor"
                                     fill="none" strokeLinecap="round" strokeLinejoin="round">
                                  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                                  <path d="M19 18a3.5 3.5 0 0 0 0 -7h-1a5 4.5 0 0 0 -11 -2a4.6 4.4 0 0 0 -2.1 8.4"/>
                                  <line x1="12" y1="13" x2="12" y2="22"/>
                                  <polyline points="9 19 12 22 15 19"/>
                                </svg>
                                <span>Free Download</span>
                              </a>
                            </div>
                          </div>

                          {/* Image */}
                          <figure className="mb-6">
                            <img className="w-2/3 rounded-sm m-auto" src={Slide03} width="640" height="360" alt="Meetup" />
                          </figure>

                          {/* Post content */}
                          <div className="text-justify">
                            <h2 className="text-xl leading-snug text-slate-800 font-bold mb-2">Key Insights</h2>
                            <p className="mb-6">People on average engage regularly with ~15 apps/brands. Depending on the brands
                              (some are pushier than others), people will receive notifications from them - updates, offers,
                              product launches, surveys, freebies etc. EmPushy found that, on average, people will actually
                              receive ~16 notifications per day, ~105 per week and ~255 per month! That's a lot of noise! This
                              doesn't include instant messaging and emails. So, with your audience already fatigued from receiving
                              so many campaigns, how can you stand out and be noticed? and how can you schedule your campaigns for
                              optimal moments that won't annoy your (already tired!) subscribers?</p>
                            <p>Use the EmPushy platform to learn what content and frequency of engagement stands out and is
                              favourable to your audience. Pushing with empathy enhances their trust in you and encourages
                              healthier, happier relationships with your followers!</p>
                          </div>
                          <hr className="my-6 border-t border-slate-200" />

                        </div>
                      </div>
                    </div>

                    {/* Article 4 */}
                    <div className="px-4 sm:px-6 lg:px-8 py-8 w-full">
                      {/* Page content */}
                      <div className="max-w-5xl mx-auto flex flex-col lg:flex-row lg:space-x-8 xl:space-x-16">
                        <div>
                          <div className="text-sm font-semibold text-pink-500 uppercase mb-2">Wed 04 May, 2022 - 1:55 PM</div>
                          <header className="mb-4">
                            {/* Title */}
                            <h1 className="text-2xl md:text-3xl text-slate-800 font-bold mb-2">Timed To Perfection</h1>
                            <p>Context is key when scheduling content to be pushed to your followers. The context of your message
                              needs to align with their state of mind, habits and activities as well as align with what is going
                              on in the world at large. Timing is an important feature of context. Certain markets verticals are
                              more applicable than others at particular times. Time to re-evaluate your schedule?</p>
                          </header>

                          {/* Meta */}
                          <div className="space-y-3 sm:flex sm:items-center sm:justify-between sm:space-y-0 mb-6">
                            {/* Author */}
                            <div className="flex items-center sm:mr-4">
                              <a className="block mr-2 shrink-0" href="#0">
                                <img className="rounded-full" src={UserImage07} width="32" height="32" alt="User 04" />
                              </a>
                              <div className="text-sm whitespace-nowrap">
                                Posted by{' '}
                                <strong className="font-semibold text-slate-800">
                                  Kieran
                                </strong>
                              </div>
                            </div>
                            {/* Right side */}
                            <div className="flex flex-wrap items-center sm:justify-end space-x-2">
                              {/* Tags */}
                              <a href={Slide04} download="empushy_insight.png"
                                 className="hover:bg-pink-400 hover:text-white text-xs inline-flex items-center font-medium bg-white text-slate-600 rounded-full text-center px-2.5 py-1">
                                {/*<svg className="w-4 h-3 fill-slate-400 mr-2" viewBox="0 0 16 12">
                            <path d="m16 2-4 2.4V2a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V7.6l4 2.4V2ZM2 10V2h8v8H2Z" />
                          </svg>*/}
                                <svg className="icon icon-tabler icon-tabler-cloud-download w-5 h-5 fill-slate-400 mr-2"
                                     width="44" height="44" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor"
                                     fill="none" strokeLinecap="round" strokeLinejoin="round">
                                  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                                  <path d="M19 18a3.5 3.5 0 0 0 0 -7h-1a5 4.5 0 0 0 -11 -2a4.6 4.4 0 0 0 -2.1 8.4"/>
                                  <line x1="12" y1="13" x2="12" y2="22"/>
                                  <polyline points="9 19 12 22 15 19"/>
                                </svg>
                                <span>Free Download</span>
                              </a>
                            </div>
                          </div>

                          {/* Image */}
                          <figure className="mb-6">
                            <img className="w-2/3 rounded-sm m-auto" src={Slide04} width="640" height="360" alt="Meetup" />
                          </figure>
                          <hr className="my-6 border-t border-slate-200" />

                        </div>
                      </div>
                  </div>
              </div>
              :contentState=='live-campaigns'?
              <LiveCampaignsContent updateContentState={updateContentState} setAlertModalState={setAlertModalState}
                                    authToken={null}/>
                :contentState=='call-to-actions'?

                          <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">

                            {/* Page header */}
                            <div className="sm:flex sm:justify-between sm:items-center mb-5">

                              {/* Left: Title */}
                              <div className="mb-4 sm:mb-0">
                                <h1 className="text-2xl md:text-3xl text-slate-800 font-bold mb-2">We ❤️ campaigns with clear and
                                  concise <i>Intents</i></h1>
                                <p className="mb-6 text-justify">...and so do your subscribers! Technology users are bombarded with hundreds and
                                  thousands of campaigns every week 🙈 If the intent of your campaign is not clear and easy to understand, your
                                  subscribers will dismiss it and move on 🏃‍ Check out the examples below which demonstrate a wide variety of good
                                  (and bad!) call-to-action campaigns 🔔</p>
                              </div>

                              {/* Right: Actions */}
                              <div className="grid grid-flow-col sm:auto-cols-max justify-start sm:justify-end gap-2"></div>

                            </div>

                            {/* Content */}
                            {ctaState=='home'?
                                <div className="grid xl:grid-cols-2 gap-6">
                                  {callToActionCards}
                                </div>:
                                <div className="flex w-full">
                                  {/* Content */}
                                  <div className="w-full">
                                    <div className="mb-6">
                                      <ul className="inline-flex flex-wrap text-sm font-medium">
                                        <li className="flex items-center">
                                          <div className="text-slate-500 hover:text-pink-500 cursor-pointer"
                                               onClick={()=>updateCTAState('home')}>Call-to-actions</div>
                                          <svg className="h-4 w-4 fill-current text-slate-400 mx-3" viewBox="0 0 16 16">
                                            <path d="M6.6 13.4L5.2 12l4-4-4-4 1.4-1.4L12 8z" />
                                          </svg>
                                        </li>
                                        <li className="flex items-center">
                                          <a className="text-slate-500">{ctaState.title}</a>
                                        </li>
                                      </ul>
                                    </div>
                                    <header className="mb-4">
                                      {/* Title */}
                                      <h1 className="text-2xl md:text-3xl text-slate-800 font-bold mb-2">{cta_emojis[ctaState.state]} {ctaState.title}</h1>
                                      <p className="mb-6 text-justify">{ctaState.textContent}</p>
                                    </header>

                                    {/* Image */}
                                    <div className="flex flex-wrap mb-5 gap-6">
                                      <div className="flex-1">
                                        <CTATrendCard data={trendData}/>
                                      </div>
                                      <div className="flex-1">
                                        <TopCategoriesCard title="Market Frequency" category="Market Vertical" data={topMarkets} palette={2}
                                                           hint={"These market verticals use the " + ctaState.title + " CTA most frequently."}/>
                                      </div>
                                    </div>



                                    <div className="flex flex-wrap mb-5 gap-6">
                                          <CTAHeatmapCard data={heatmapData} title={'Popular Delivery Times for "'+ctaState.title+'" Campaigns'}
                                                          hint={'Scheduled delivery of messages to audience subscribers.'}/>
                                    </div>

                                    <div className="flex flex-wrap mb-5 gap-6">
                                      <CTACampaignsCard data={campaigns} cta={ctaState.title} setModalState={setCTAModalState}/>
                                    </div>

                                    <div className="flex flex-wrap mb-5 gap-6">
                                      <div className="flex-1">
                                        <TopCategoriesCard title={'Trending Emotion in "'+ctaState.title+'" campaigns'} category="Emotion" data={emotions} palette={0}
                                                           hint="Trending use of emotion found in the text content of campaigns
                                (based on an analysis of campaigns pushed over the past 7 days)"
                                                           filterFunc={filterAssociatedNotifs}/>
                                      </div>
                                      <div className="flex-1">
                                        <TopCategoriesCard title={'Trending Tone in "'+ctaState.title+'" campaigns'} category="Tone" data={tones} palette={1}
                                                           hint="Trending use of tone found in the text content of campaigns
                              (based on an analysis of campaigns pushed over the past 7 days)"
                                                           filterFunc={filterAssociatedNotifs}/>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                            }

                          </div>
                          :''
            }
            <AlertModal params={alertModalState} toggleState={setAlertModalState}/>
              <CTAModal params={ctaModalState} toggleState={setCTAModalState}/>

          </main>
        </div>
      </div>
  );
}

export default Landing;